import { useMemo } from 'react'
import { useApiSWRReference } from './useApiSWR'

/**
 * The profiles list, cached once for the whole session.
 *
 * Goes through `useApiSWR` and not a bare `useSWR(…, requestGet)`: the cache
 * entry is keyed by endpoint and shared with every other reader of
 * `/profiles/all`. Two hooks fetching one key with two fetchers store two
 * shapes — the axios response for one, the body for the other — and whichever
 * mounts first decides what the others read.
 */
export default function useProfiles() {
    const { data } = useApiSWRReference('/profiles/all')

    const profiles = data?.mentionable ?? []
    const profilesMap = useMemo(
        () => Object.fromEntries((data?.all ?? []).map((p) => [p.id, p])),
        [data],
    )

    return { profiles, profilesMap }
}
